<template>
	<div class="container">
		<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
			<van-swipe-item v-for="item in data.attach_list" :key="item.id">
				<img :src="item.url" :alt="item.filename" />
			</van-swipe-item>
		</van-swipe>
		<h3 class="title">{{ data.room_name }}</h3>
		<p class="capacity">{{ data.capacity }}人 | {{ data.display_area }} ㎡ | {{ typeLists[data.property_id_space_type] }}</p>
		<div class="priceInfo">
			<div class="priceType">
				<span class="price">{{ data.price_hour }} </span>元/小时
			</div>
			<div class="priceType">
				<span class="price">{{ data.price_half_day }} </span>元/半天
			</div>
			<div class="priceType">
				<span class="price">{{ data.price_day }} </span>元/天
			</div>
			<div class="priceType">
				<span class="price">{{ data.price_week }} </span>元/周
			</div>
			<div class="priceType">
				<span class="price">{{ data.price_month }} </span>元/月
			</div>
		</div>
		<div class="roomDevices">
			<div class="roomDevicesItem" v-for="(item, index) in data.property_basic_list" :key="index">{{ item }}</div>
		</div>
		<p class="address">
			<svg t="1629100880805" style="margin-right: 3px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2580" width="13" height="13">
				<path
					d="M512 12c-199.11 0-361.11 162-361.11 361.11 0 191.45 325.36 610.46 339.22 628.2a27.76 27.76 0 0 0 43.78 0c13.86-17.74 339.22-436.75 339.22-628.2C873.11 174 711.11 12 512 12z m0 926.54C409.87 803.08 206.44 505.87 206.44 373.11c0-168.48 137.08-305.55 305.56-305.55s305.56 137.07 305.56 305.55c0 132.76-203.43 429.97-305.56 565.43z"
					p-id="2581"
				></path>
				<path
					d="M512 178.67c-107.2 0-194.44 87.23-194.44 194.44S404.8 567.56 512 567.56s194.44-87.23 194.44-194.44S619.2 178.67 512 178.67zM512 512c-76.58 0-138.89-62.31-138.89-138.89S435.42 234.22 512 234.22s138.89 62.31 138.89 138.89S588.58 512 512 512z"
					p-id="2582"
				></path>
			</svg>
			{{ data.address }}
		</p>
		<div class="splitLine"></div>
		<h3 class="introductionTitle">详细介绍</h3>
		<div class="content" v-html="data.content"></div>
	</div>
</template>

<script>
import toastLoading from '../../util/toastLoading'
export default {
	data() {
		return {
			data: {},
			typeLists: {
				'100': '会议室',
				'101': '路演厅',
				'102': '直播间',
				'103': '洽谈室',
				'104': '独立办公间',
				'105': '公共办公间',
				'106': '智慧智能柜',
				'107': '广告机',
			},
		}
	},
	created() {
		this.getData()
	},
	methods: {
		async getData() {
			toastLoading.showLoading('加载中...')
			try {
				let res = await this.vaxios.getApi(`${this.vaxios.host}/open/api/v1/investments/room/${this.$route.query.id}/detail`)
				toastLoading.clearLoading()
				if (res.code !== 1 || !res.data) return
				this.data = res.data || []
			} catch (_) {
				toastLoading.clearLoading()
			}
		},
	},
}
</script>

<style>
.container {
	margin: 16px;
}
.my-swipe {
	border-radius: 8px;
}

.my-swipe .van-swipe-item {
	width: 100%;
	height: 165px;
}

.my-swipe .van-swipe-item img {
	width: 100%;
	height: 100%;
}
.title {
	margin-top: 10px;
	margin-bottom: 0;
	color: #272727;
	font-size: 16px;
	font-weight: normal;
}
.capacity {
	margin-top: 10px;
	margin-bottom: 0;
	color: #666;
	font-size: 12px;
}
.priceInfo {
	margin-top: 12px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.priceType {
	color: #000;
	font-size: 12px;
}
.price {
	color: #fc5e18;
	font-size: 15px;
}
.roomDevices {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	margin-top: 15px;
}
.roomDevicesItem {
	font-size: 12px;
	color: #9b9b9b;
	padding: 2px 10px;
	border: 1px solid #b8b8b8;
	border-radius: 5px;
	margin-right: 5px;
}
.address {
	margin-top: 15px;
	margin-bottom: 16px;
	font-size: 13px;
	color: #000;
}
.splitLine {
	background-color: #f6f6f6;
	width: 100%;
	height: 8px;
	padding-right: 16px;
	padding-left: 16px;
	margin-left: -16px;
}

.content {
	margin-top: 2.53125rem;
	color: #272727;
	font-size: 1rem;
	padding-bottom: 30px;
}

.content img {
	display: block;
	width: 100%;
	height: 100%;
}

.withoutContent {
	margin-top: 20%;
	display: flex;
	justify-content: center;
}
.content /deep/ img {
	width: 100% !important;
}

.introductionTitle {
	font-size: 17px;
	color: #000;
	margin-top: 16px;
	margin-bottom: 16px;
	font-weight: normal;
}
</style>
